import React from 'react';
import { connect } from 'react-redux';
import { ASSETS_FOLDER } from '../../../../constants';
import './SceneSpot.css';

const SceneSpot = props => {
  const { type, data, positionId, scale, hoveredSpot, hiliteId } = props;

  // show/hide + hilite
  const isActive = positionId === hoveredSpot;
  const hilite = hiliteId.length === 0 || data.hiliteId === hiliteId;

  // position
  const spotStyle = {
    left: data.pos.x * scale,
    backgroundColor: data.color,
  };
  if (type === 1) {
    spotStyle.bottom = data.pos.y * scale;
  } else {
    spotStyle.top = data.pos.y * scale;
  }

  return (
    <div
      className={`scene-spot ${isActive ? 'active' : ''} ${
        hilite ? 'hilite' : ''
      }`}
      style={spotStyle}
    >
      <img src={`${ASSETS_FOLDER}img/ico/bullet-map-${data.ico}.png`} alt="" />
    </div>
  );
};

const mapStateToProps = state => ({
  scale: state.ui.scale,
  hoveredSpot: state.app.hoveredSpot,
  hiliteId: state.app.hiliteId,
});

export default connect(mapStateToProps)(SceneSpot);



// WEBPACK FOOTER //
// ./src/components/Shared/SceneSpotGroup/SceneSpot/SceneSpot.js